import React, { memo } from "react";

// DS
import { Tag } from "@toddle-edu/ds-web";

import classes from "./NewTag";

const NewTag = memo(props => {
  const { t, isNewTagVisible } = props;

  return isNewTagVisible ? (
    <div className={classes.container}>
      <Tag size={"x-small"} color={"yellow"}>
        {t("common:new")}
      </Tag>
    </div>
  ) : null;
});

NewTag.displayName = "NewTag";

export default NewTag;
